import { Component, OnInit } from '@angular/core';
import { Ademas } from '../../models/ademas';
import { MoreService } from '../../service/more.service';

@Component({
  selector: 'app-detalle-more',
  templateUrl: './detalle-more.component.html',
  styleUrls: ['./detalle-more.component.css']
})
export class DetalleMoreComponent implements OnInit {
  more: Ademas;

  constructor(private dataservice: MoreService) {
    this.more = dataservice.more;
  }

  ngOnInit() {
     // ocultar grafica Photoshop
     const valorPhotoshop = this.more.porcentajePhotoshop;
     if (valorPhotoshop === '0' || valorPhotoshop === '') {

       document.querySelector('#porcentajephotoshop').parentElement.parentElement.style.display = 'none';
     }
      // ocultar grafica Illustrator
     const valorIllustrator = this.more.porcentajeIllustrator;
     if (valorIllustrator === '0' || valorIllustrator === '') {

       document.querySelector('#porcentajeillustrator').parentElement.parentElement.style.display = 'none';
     }
      // ocultar grafica Maya
     const valorMaya = this.more.porcentajeMaya;
     if (valorMaya === '0' || valorMaya === '') {

       document.querySelector('#porcentajemaya').parentElement.parentElement.style.display = 'none';
     }
     // ocultar grafica Zbrush
     const valorZbrush = this.more.porcentajeZbrush;
     if (valorZbrush === '0' || valorZbrush === '') {

       document.querySelector('#porcentajezbrush').parentElement.parentElement.style.display = 'none';
     }

     // ocultar imgmore2
     const valorImgmore2 = this.more.imagenDetalle2;
     if (valorImgmore2 === '') {

       document.querySelector('#imgmore2').parentElement.parentElement.parentElement.style.display = 'none';
     }

     // ocultar imgmore3
     const valorImgmore3 = this.more.imagenDetalle3;
     if (valorImgmore3 === '') {

       document.querySelector('#imgmore3').parentElement.parentElement.style.display = 'none';
     }

     // ocultar imgmore4
     const valorImgmore4 = this.more.imagenDetalle4;
     if (valorImgmore4 === '') {

       document.querySelector('#imgmore4').parentElement.parentElement.style.display = 'none';
     }

     // ocultar empresa
     const valorEmpresa = this.more.empresaAdemas;
     if (valorEmpresa === '') {

       document.querySelector('#empresaAdemas').parentElement.style.display = 'none';
     }
  }

}
